import React from 'react';
import { Shield, Lock, Eye, Server } from 'lucide-react';

export function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Security Features */}
          <div>
            <h3 className="text-lg font-semibold mb-4 flex items-center space-x-2">
              <Shield className="w-5 h-5 text-security-400" aria-hidden="true" />
              <span>Security</span>
            </h3>
            <ul className="space-y-3 text-sm text-gray-300">
              <li className="flex items-center space-x-2">
                <Lock className="w-4 h-4 text-security-400" aria-hidden="true" />
                <span>End-to-end encryption</span>
              </li>
              <li className="flex items-center space-x-2">
                <Eye className="w-4 h-4 text-security-400" aria-hidden="true" />
                <span>Zero-knowledge architecture</span>
              </li>
              <li className="flex items-center space-x-2">
                <Server className="w-4 h-4 text-security-400" aria-hidden="true" />
                <span>Secure cloud storage</span>
              </li>
            </ul>
          </div>
          
          {/* Privacy */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Privacy</h3>
            <ul className="space-y-3 text-sm text-gray-300">
              <li>
                <span>Files encrypted on server</span>
              </li>
              <li>
                <span>Automatic link expiration</span>
              </li>
              <li>
                <span>No permanent file storage</span>
              </li>
              <li>
                <span>Minimal data collection</span>
              </li>
            </ul>
          </div>
          
          {/* How it Works */}
          <div>
            <h3 className="text-lg font-semibold mb-4">How It Works</h3>
            <ol className="space-y-3 text-sm text-gray-300">
              <li className="flex">
                <span className="text-primary-400 font-semibold mr-2">1.</span>
                <span>Create secure upload request</span>
              </li>
              <li className="flex">
                <span className="text-primary-400 font-semibold mr-2">2.</span>
                <span>Send link to recipient</span>
              </li>
              <li className="flex">
                <span className="text-primary-400 font-semibold mr-2">3.</span>
                <span>Files uploaded and encrypted</span>
              </li>
              <li className="flex">
                <span className="text-primary-400 font-semibold mr-2">4.</span>
                <span>Access files securely</span>
              </li>
            </ol>
          </div>
          
          {/* Trust Indicators */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Trust & Compliance</h3>
            <div className="space-y-3 text-sm text-gray-300">
              <div className="security-badge bg-security-900 text-security-100 ring-security-700">
                🔒 AES-256 Encryption
              </div>
              <div className="security-badge bg-primary-900 text-primary-100 ring-primary-700">
                🛡️ SOC 2 Compliant
              </div>
              <div className="security-badge bg-gray-800 text-gray-100 ring-gray-600">
                🔐 Zero-Knowledge
              </div>
            </div>
          </div>
        </div>
        
        {/* Bottom bar */}
        <div className="mt-8 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex items-center space-x-2">
              <Shield className="w-5 h-5 text-primary-400" aria-hidden="true" />
              <span className="font-semibold">SecureTransfer</span>
              <span className="text-gray-400">- Enterprise-grade security</span>
            </div>
            <p className="text-gray-400 text-sm mt-4 md:mt-0">
              © 2025 Omniscope SecureTransfer. Your files are always safe.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
